// Machine price label. The machine (and the pre-loved unit, which IS the
// machine) shows BOTH the cash sticker and the estimated monthly inline:
//
//   $45,999 · $543 /mo
//
// Accessories and tables intentionally do NOT use this — they show cash only
// (plain formatDollars). The monthly here is a per-line comparison figure on
// the machine's own price; down payment + tax are amortized once at the
// Summary total, not per line.

import { amortizedMonthlyCents, formatDollars, formatMonthly } from "./format";
import { CREDIT_APRS, useConfigurator } from "./store";

export function useMachineDualPriceLabel(): (cents: number) => string {
  const { state } = useConfigurator();
  return (cents: number) => {
    const apr = CREDIT_APRS[state.financing.creditTier];
    const monthly = formatMonthly(
      amortizedMonthlyCents(cents, apr, state.financing.termMonths),
    );
    return `${formatDollars(cents)} · ${monthly}`;
  };
}
